<div class="py-4">
    <div class="py-4">
        <app-solicitud-servicio 
            [title]="'Gestión de la solicitud de servicio'" 
            [$views]="10"
            [submitted]="submitted" 
            [solicitudGestion]="solicitud"
            (SolicitudEvent)="catchRequestService($event)">
        </app-solicitud-servicio>

        <!-- SECCION CONSULTA -->
        <div *ngIf="true">
            <ng-container *ngTemplateOutlet="seccion_consulta"></ng-container>
        </div>

        <!-- SECCION VINCULAR SOLICITUD -->
        <ng-container [ngTemplateOutlet]="vincularSolicitud"></ng-container>
    </div>

    <div class="container d-flex flex-row justify-content-end gap-2">
            <button type="button" class="btn btn-secondary col-md-2" (click)="modalGestion()">
                GESTIONAR SOLICITUD
            </button>
            <button type="button" class="btn btn-secondary col-md-2" (click)="onCambiarEstado()">
                NO PROCEDENTE
            </button>
            <button type="button" class="btn btn-secondary col-md-2" (click)="addNovedad(novedad)">
                AGREGAR NOVEDAD
            </button>
            <button type="button" class="btn btn-secondary col-md-2" [routerLink]="['/bandeja-programador']">
                CANCELAR
            </button>
    </div>
</div>



<!-- SECCION CONSULTA SOLICITUDES DISPONIBLES PARA PROGRAMACION -->
<ng-template #seccion_consulta>
    <div class="container">
        <app-table-consult-request-programmer
            [actions]="false"
            [dataTable]="solicitud">
        </app-table-consult-request-programmer>

        <br>
        <br>
    </div>
</ng-template>


<!-- SECCION VINCULAR SOLICITUD DE SERVICIO -->
<ng-template #vincularSolicitud>
    <div class="container column">
        <h6 class="text-secondary fw-bold">Vincular una solicitud de servicio disponible para programación</h6>

        <div class="container card rounded-0 border-bottom-0 border-end-0 border-start-0 border-secondary border-3">
            <br>
            
            <span>Desea vincular una solicitud de servicio adicional a la visualizada en modo consulta para programación</span>
            <br>
            <div class="col-2 mb-4">
                <button type="button" class="btn btn-secondary col-12" (click)="this.$vincularSolicitud = true">
                    ACEPTAR
                </button>
            </div>
        </div>

        <br>
        <br>

        <!-- SECCION CONSULTA SOLICITUDES DISPONIBLES PARA PROGRAMACION -->
        <div class="container" *ngIf="$vincularSolicitud">
            <app-table-consult-request-programmer
                [actions]="true">
            </app-table-consult-request-programmer>

            <br>
            <br>
        </div>
    </div>
</ng-template>


<!-- ================================================================================================================== -->


<!-- MODAL AGREGAR NOVEDAD EN LA SOLICITUD DEL SERVICIO -->
<ng-template #novedad let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title text-secondary" id="modal-basic-title">
            <strong class="text-secondary">Agregar novedad en la solicitud de servicio</strong>
        </h4>
    </div>

    <div class="modal-body py-3">
        <app-agregar-novedad
            [codeSolicitud]="solicitud.id"
            [solicitud]="solicitud"
            (cancel)="addNovedad($event)"
            (reloadTable)="getSolicitudById($event)">
        </app-agregar-novedad>
    </div>
</ng-template>



<!-- MODAL PARA GESTIONAR LA SOLICITUD -->

<ng-template #gestion_solicitud let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title text-secondary" id="modal-basic-title">
            <strong class="text-secondary">Gestión de la solicitud de transporte</strong>
        </h4>
    </div>

    <div class="modal-body py-3">
        <app-gestion-solicitud-transporte
            [solicitudID]="solicitudId"
            (closedModal)="modalGestion($event)">
        </app-gestion-solicitud-transporte>
    </div>
</ng-template>
<!-- Objeto para mostrar archivo adjunto -->
<!-- <object
    data="data:application/pdf;base64,{{$infoRadicado->documento_base64}}"
    type="application/pdf" width="100%" height="600px">
</object> -->